import { getAgoraRtcToken, markMeetingJoined } from './backend';

const AGORA_CDN = 'https://cdn.jsdelivr.net/npm/agora-rtc-sdk-ng@4.24.6/AgoraRTC_N-production.js';

export function loadAgoraRtc() {
  return new Promise((resolve, reject) => {
    if (window.AgoraRTC) return resolve(window.AgoraRTC);
    const existing = document.querySelector('script[data-telcofair-agora="true"]');
    if (existing) {
      existing.addEventListener('load', () => window.AgoraRTC ? resolve(window.AgoraRTC) : reject(new Error('Agora SDK did not initialize.')), { once: true });
      existing.addEventListener('error', () => reject(new Error('Unable to load Agora Web SDK.')), { once: true });
      return;
    }
    const script = document.createElement('script');
    script.src = AGORA_CDN;
    script.async = true;
    script.dataset.telcofairAgora = 'true';
    script.onload = () => window.AgoraRTC ? resolve(window.AgoraRTC) : reject(new Error('Agora SDK did not initialize.'));
    script.onerror = () => reject(new Error('Unable to load Agora Web SDK.'));
    document.head.appendChild(script);
  });
}

export async function fetchAgoraToken(companyId, channelName, uid, role = 'publisher', meetingId = '') {
  return getAgoraRtcToken(companyId, { channelName, uid, role, meetingId });
}

export async function confirmMeetingJoin(meetingId) { return markMeetingJoined(meetingId); }


export default { loadAgoraRtc, fetchAgoraToken, confirmMeetingJoin };
